import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import RDCard from './RDCard';
import recentDevelopments from '../../../assets/data/recentDevelopments';

function RecentDevelopmentsSection() {
  return (
    <Box sx={{ width: { xs: '90%', md:'95%', mdlg: '65%', lg: '72%' } }} >
      <Box sx={{ textAlign: 'center' }} >
        <Typography sx={{ fontSize: { xs: '1.5rem', md: '1.8rem' }, fontWeight: '600' }} >RECENT DEVELOPMENTS</Typography>
      </Box>
      <Grid
        container
        justifyContent={{ xs: 'start', md: 'space-around', mdlg: 'start', lg: 'center' }}
        alignItems="center"
        rowSpacing={2}
        columnSpacing={{ xs: 0, md: 1, mdlg: 20, lg: 1 }}
        sx={{ mx: { xs: 0.5, sm: 2.5, md: 0, mdlg: 0, lg: 2 }, my: 3 }}
      >
        {recentDevelopments.map((recentDevelopment) => (
          <Grid size={{ xs: 7, md: 5, lg: 4 }} key={recentDevelopment} >
            <RDCard recentDevelopment={recentDevelopment} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default RecentDevelopmentsSection
